import type { ReactNode } from 'react';

export type BkPageProps = {
  children: ReactNode;
  className?: string;
  narrow?: boolean;
  fullHeight?: boolean;
};

export default function BkPage({
  children,
  className = '',
  narrow = false,
  fullHeight = false,
}: BkPageProps) {
  return (
    <div
      className={[
        'mx-auto w-full px-4 sm:px-6 lg:px-10 py-4 sm:py-6 lg:py-8',
        narrow ? 'max-w-3xl' : 'max-w-6xl',
        fullHeight ? 'min-h-full flex flex-col' : '',
        className,
      ].join(' ')}
    >
      {children}
    </div>
  );
}
